import React from 'react'
import Layout from '../../Layout'
import HeaderMain from '../../Components/HeaderMain'
import { useAuth } from '../../Hook/App';
import { useNavigate } from 'react-router-dom';
function Auth() {
    const { loading, page, send, onChange } = useAuth();
    const navigation = useNavigate();
    return (
        <Layout nav={false}>
            <HeaderMain lable="ورود به حساب کاربری" back={() => { navigation('/') }} />
            {page === 'auth' ?
                <ViewAuth send={send} loading={loading} onChange={onChange} />
                :
                <ViewVerify send={send} loading={loading} onChange={onChange} />
            }
        </Layout>
    )
}

const ViewAuth = ({ onChange, send, loading }) => {
    return (
        <div className='main auth'>
            <div className="container">
                <div className='text-center mb-5'>
                    <p>برای ثبت نام یا ورود ، شماره تلفن خود را وارد نمایید.</p>
                </div>
                <div className="form-group">
                    <label htmlFor="">شماره تلفن همراه</label>
                    <input type="tel" name='mobile' onChange={onChange} />
                </div>
                <small>توجه : لطفا پس از ثبت آگهی ، از طریق هیچ پیامکی برای پرداخت وجه جهت انتشار آگهی اقدام نکنید</small>

            </div>
            <div className='btn-login' onClick={send}><span>{loading ? <div className='spinner-border spinner-border-sm'></div> : "ورود و ثبت نام"}</span></div>

        </div>
    )
}

const ViewVerify = ({ onChange, send, loading }) => {
    return (
        <div className='main auth'>
            <div className="container">
                <div className='text-center mb-5'>
                    <p>کد احراز هویت که برای شما پیامک شده را وارد کنید.</p>
                </div>
                <div className="form-group">
                    <label htmlFor="">کد تایید</label>
                    <input type="number" name='code' onChange={onChange} />
                </div>
                <small>توجه : لطفا پس از ثبت آگهی ، از طریق هیچ پیامکی برای پرداخت وجه جهت انتشار آگهی اقدام نکنید</small>

            </div>
            <div className='btn-login' onClick={send}><span>{loading ? <div className='spinner-border spinner-border-sm'></div> : "تایید کد"}</span></div>
        </div>
    )
}

export default Auth